<template>
  <div>
    <div v-if="!errorGettingNotification">
      <v-form ref="form" v-model="valid">
        <v-row>
          <v-col>
            <v-row>
              <v-col cols="auto">
                <h4 class="secondary--text mb-4">
                  {{ 
                    $t(
                        'fleet_management.agents.agent_detail.labels.notifications_recipients'
                      )  
                  }}
                </h4>
                <div class="mt-2 mb-2" v-if="!editable">
                  <v-row>
                    <v-col>
                      <span class="tertiary--text text-body-2">
                        {{ 
                          $t(
                              'fleet_management.agents.agent_detail.labels.card_field_notifications_persons'
                            )  
                        }}
                      </span>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <div v-if="loading" class="text-center">
                        <v-progress-circular
                          indeterminate
                          color="primary"
                        ></v-progress-circular>
                      </div>
                      <template v-for="(item, index) in persons">
                        <v-chip
                          class="mr-2 mb-2"
                          v-if="index < personsToShow"
                          :key="item.id"
                        >
                          <v-avatar left v-if="item.roles !== null">
                            <v-img
                              :src="item.item.avatar"
                              v-if="checkAvatar(item)"
                            ></v-img>
                            <v-icon v-else>
                              mdi-account
                            </v-icon>
                          </v-avatar>
                          <span>{{ item.firstName }} {{ item.lastName }}</span>
                        </v-chip>
                      </template>
                      <span
                        class="secondary--text mr-2"
                        v-if="personsToShow < persons.length && personsToShow <= 10"
                      >
                        {{ 
                          $t(
                            'fleet_management.agents.agent_detail.labels.recipients_total', { count: persons.length }
                            ) 
                        }}
                      </span>
                      <span
                        class="secondary--text mr-2"
                        v-if="personsToShow < persons.length && personsToShow > 10"
                      >
                        ( +{{ persons.length - personsToShow }} )
                      </span>
                      <v-btn
                        small
                        color="primary"
                        text
                        v-on="$listeners"
                        v-if="personsToShow < persons.length"
                        @click="showMorePersons"
                      >
                        <v-icon left>
                          mdi-plus-circle-outline
                        </v-icon>
                        <span class="text-capitalize text-body-2">
                          Ver más
                        </span>
                      </v-btn>
                    </v-col>
                  </v-row>
                  <v-row>
                    <v-col>
                      <slot
                        name="tagsPersonSlot"
                        :tagsPersonIsEmpty="
                          value => (tagsPersonIsEmpty = value)
                        "
                      ></slot>
                    </v-col>
                  </v-row>
                </div>
                <v-expansion-panels
                  v-else
                  class="elevation-0"
                  style="box-shadow: none !important"
                  multiple
                  :disabled="false"
                >
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span class="tertiary--text text-body-2">
                        {{ 
                          $t(
                              'fleet_management.agents.agent_detail.labels.card_field_notifications_persons'
                            )  
                        }}
                      </span>
                    </v-expansion-panel-header>
                    <v-expansion-panel-content>
                      <v-row>
                        <v-col cols="auto">
                          <v-autocomplete
                            id="idEventosDestinatarios"
                            v-model="persons"
                            color="tertiary"
                            chips
                            filled
                            dense
                            hide-details="auto"
                            :items="items"
                            item-text="fullName"
                            item-value="id"
                            multiple
                            return-object
                            :loading="loading"
                            @input="addRecipientsInput"
                          >
                            <template v-slot:prepend-item>
                              <v-list-item
                                id="idEventosDestinatariosSeleccionarTodos"
                                ripple
                                @click="selectAll"
                              >
                                <v-list-item-action>
                                  <v-icon>
                                    {{ iconSellectAll }}
                                  </v-icon>
                                </v-list-item-action>
                                <v-list-item-content>
                                  <v-list-item-title>
                                    {{ 
                                      $t(
                                          'fleet_management.agents.agent_detail.labels.form_title_select_alls'
                                        )  
                                    }} 
                                  </v-list-item-title
                                  >
                                </v-list-item-content>
                              </v-list-item>
                              <v-divider class="mt-2"></v-divider>
                            </template>
                            <template
                              v-slot:item="data"
                              style="max-height: 50px;"
                            >
                              <v-checkbox
                                v-model="data.item.checked"
                                :value="data.item.checked"
                              ></v-checkbox>
                              <span
                                :id="data.item.domElementId"
                                @click="data.item.checked = !data.item.checked"
                                class="dropdown-element-style py-6"
                              >
                                {{ data.item.fullName }}
                              </span>
                            </template>
                            <template v-slot:selection="{ item, index }">
                              <v-chip
                                v-if="index < 3"
                                v-bind="item.attrs"
                                :input-value="item.selected"
                                :close="editable"
                                @click="item.select"
                                @click:close="remove(item)"
                              >
                                <v-avatar left v-if="item.roles !== null">
                                  <v-img
                                    :src="item.item.avatar"
                                    v-if="checkAvatar(item)"
                                  ></v-img>
                                  <v-icon>
                                    mdi-account
                                  </v-icon>
                                </v-avatar>
                                {{ item.fullName }}
                              </v-chip>
                              <span
                                v-else-if="index === 3"
                                class="grey--text caption"
                              >
                                (+{{ persons.length - 3 }})
                              </span>
                            </template>
                          </v-autocomplete>
                        </v-col>
                      </v-row>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                  <v-expansion-panel>
                    <v-expansion-panel-header>
                      <span class="tertiary--text text-body-2">
                        {{ 
                          $t(
                              'fleet_management.agents.agent_detail.labels.group_persons'
                            )  
                        }} 
                      </span
                      >
                    </v-expansion-panel-header>
                    <v-expansion-panel-content :eager="true">
                      <slot
                        name="tagsPersonSlot"
                        :tagsPersonIsEmpty="
                          value => (tagsPersonIsEmpty = value)
                        "
                        :baseTagDataSubmitted="baseTagDataSubmitted"
                      ></slot>
                    </v-expansion-panel-content>
                  </v-expansion-panel>
                </v-expansion-panels>
                <span class="red--text text-caption">{{ errorMessage }}</span>
              </v-col>
            </v-row>
            <v-row>
              <v-col cols="12">
                <span class="secondary--text">
                  {{
                    $t(
                      'fleet_management.agents.agent_detail.labels.notifications_title'
                    )
                  }}
                </span>
              </v-col>
              <v-checkbox
                id="idEventosNotificacionesBandeja"
                class="mt-0 pl-2 pr-6 pb-5"
                @click="checkInputs"
                :label="
                  $t(
                    'fleet_management.agents.agent_detail.labels.inbox_checkbox'
                  )
                "
                color="secondary"
                hide-details="auto"
                :readonly="!editable"
                v-model="inbox"
                :error-messages="errorCheckbox"
              ></v-checkbox>
              <v-checkbox
                id="idEventosNotificacionesViaEmail"
                class="mt-0 px-2 pb-5"
                v-model="byEmail"
                :label="
                  $t(
                    'fleet_management.agents.agent_detail.labels.email_checkbox'
                  )
                "
                hide-details="auto"
                color="secondary"
                :readonly="!editable"
                @click="checkInputs"
                :error-messages="errorCheckbox"
              ></v-checkbox>
<!--              Ocultado por SF-2526 Prod-->
<!--              <v-checkbox-->
<!--                class="mt-0 px-2 pb-5"-->
<!--                v-model="byMobile"-->
<!--                :label="-->
<!--                  $t(-->
<!--                    'fleet_management.agents.agent_detail.labels.mobile_checkbox'-->
<!--                  )-->
<!--                "-->
<!--                hide-details="auto"-->
<!--                color="secondary"-->
<!--                :readonly="!editable"-->
<!--                @click="checkInputs"-->
<!--                :error-messages="errorCheckbox"-->
<!--                id="idNotificacionesMobile"-->
<!--              ></v-checkbox>-->
            </v-row>
            <v-row>
              <v-col cols="3">
                <div class="tertiary--text text-body-2">
                  {{ 
                    $t(
                    'fleet_management.agents.agent_detail.labels.card_field_criticality'
                    )
                  }}
                </div>
                <div v-if="loadingCriticality" class="d-flex align-center">
                  <v-progress-circular indeterminate color="primary" />
                </div>
                <div v-if="editable">
                  <v-select
                    v-model="selectedCriticality"
                    :items="criticalityLevels"
                    item-text="text"
                    item-value="value"
                    dense
                    filled
                    :rules="[
                      v => !!v || 
                      $t('fleet_management.persons.new_person.rules.select_required')
                    ]"
                    :return-object="true"
                  >
                    <template v-slot:selection="{ item }">
                      <v-chip
                        v-if="item"
                        :color="item.color"
                        label
                        outlined
                        small
                        class="mt-1"
                      >
                        <v-icon left :color="item.color">
                          mdi-alert-circle
                        </v-icon>
                        <span 
                          :key="item.color"
                          :class="`${item.color}--text`"
                        >
                          {{ item.text }}
                        </span>
                      </v-chip>
                    </template>
                  </v-select>
                </div>

                <div v-else>
                  <v-chip
                    v-if="selectedCriticalityObject"
                    :color="selectedCriticalityObject.color"
                    label
                    outlined
                    class="mt-1"
                  >
                    <v-icon left :color="selectedCriticalityObject.color">
                      mdi-alert-circle
                    </v-icon>
                    <span
                        :key="selectedCriticalityObject.color"
                        :class="`${selectedCriticalityObject.color}--text`"
                    >
                      {{ selectedCriticalityObject.text }}
                    </span>
                  </v-chip>
                </div>
              </v-col>
            </v-row>
          </v-col>
        </v-row>
      </v-form>
    </div>
    <div v-else>
      <v-row>
        <v-col cols="12">
          <p class="h2 secondary--text font-weight-bold text-center">
            {{
              $t(
                'fleet_management.agents.notifications.errors.unexpected_error'
              )
            }}
          </p>
        </v-col>
      </v-row>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import PersonsHelpers from '@/helpers/persons/personsHelpers'
import NotificationsHelper from '@/helpers/notifications/notifications'
import AgentsHelpers from '@/helpers/agents/agentsHelpers'
import { firebaseServices } from '@leapsight/styleguide'
import { FirebaseTagNames } from '@leapsight/portal'
import { i18n } from '@leapsight/portal'

export default {
  props: {
    isAdmin: {
      type: Boolean,
      default: true
    },
    isAdminSubFleet: {
      type: Boolean,
      default: true
    },
    editable: {
      type: Boolean,
      default: false
    },
    onNotificationValueChange: {
      type: Function,
      default: v => ({})
    }
  },
  data() {
    return {
      tagsPersonIsEmpty: true,
      agent: [],
      agentId: '',
      byEmail: false,
      byEmailOriginal: false,
      byMobile: false,
      byMobileOriginal: false,
      errorGettingNotification: false,
      hasNotificationConfig: false,
      inbox: false,
      inboxOriginal: false,
      items: [],
      persons: [],
      initialRecipients: [],
      personsNotificationConfig: [],
      valid: true,
      loading: true,
      loadingCriticality: true,
      selectAllPersons: false,
      personsToShow: 10,
      personsGroupNotificationIds: [],
      originalCriticality: null,
      selectedCriticality: null,
      criticalityLevels: [
        { value: 10, text: 'Baja', color: 'green' },
        { value: 20, text: 'Media', color: '#3480C8' },
        { value: 30, text: 'Alta', color: 'orange' },
        { value: 40, text: 'Crítica', color: 'red' },
      ],
    }
  },
  methods: {
    ...mapActions('ui', ['setSnackbar']),
    ...mapActions('tags', ['getTagsList']),
    baseTagDataSubmitted(data) {
      this.personsGroupNotificationIds = data.map(el => el.uriId)
    },
    addRecipientsInput() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENT_ADD_RECIPIENTS
      )
    },
    showMorePersons() {
      this.personsToShow += 10
    },
    selectAll() {
      if (this.selectAllPersons) {
        this.persons.forEach(element => {
          element.checked = false
        })
        this.persons = []
      } else {
        this.persons = [...this.items]
        this.persons.forEach(element => {
          element.checked = true
        })
      }
      this.selectAllPersons = !this.selectAllPersons
    },
    autoCheckInputs() {
      if (this.persons.length > 0) {
        for (let i = 0; i < this.persons.length; i++) {
          if (this.persons[i].roles) {
            if (this.byEmailOriginal) {
              this.byEmail = true
            } else if (this.byMobileOriginal) {
              this.byMobile = true
            } else {
              this.inbox = true
            }
          }
        }
      } else if (this.tagsPersonIsEmpty) {
        this.inbox = false
        this.byEmail = false
        this.byMobile = false
      }
    },
    cancel() {
      this.resetValues()
      this.fillNotifications()
      this.toggleEditable()
    },
    checkAvatar(item) {
      return typeof item.avatar !== 'undefined' ? true : false
    },
    checkInputs() {
      firebaseServices.logEvent(
        firebaseServices.analytics,
        FirebaseTagNames.INP_FLEET_MANAGEMENT_AGENT_TYPE_NOTIFICATIONS
      )
    },
    fillNotifications() {
      if (
        this.hasNotificationConfig &&
        Array.isArray(this.personsNotificationConfig) &&
        this.personsNotificationConfig.length > 0
      ) {
        this.byEmail = this.personsNotificationConfig.some(
          personNotification =>
            'channels' in personNotification &&
            'email' in personNotification.channels
        )
        this.byEmailOriginal = this.byEmail
        this.inbox = this.personsNotificationConfig.some(
          personNotification =>
            'channels' in personNotification &&
            'inbox' in personNotification.channels
        )
        this.inboxOriginal = this.inbox
        this.byMobile = this.personsNotificationConfig.some(
          personNotification => {
            return (
              'channels' in personNotification &&
              'push' in personNotification.channels
            )
          }
        )
        this.byMobileOriginal = this.byMobile

        for (let i = 0; i < this.items.length; i++) {
          const item = this.items[i]
          for (
            let index = 0;
            index < this.personsNotificationConfig.length;
            index++
          ) {
            const person = this.personsNotificationConfig[index]
            if (
              item.id === person.user_id &&
              !this.persons.some(p => p.id === item.id)
            ) {
              item.checked = true
              this.persons.push(item)
            }
          }
        }
        this.initialRecipients = structuredClone(this.persons)
      }
    },
    async getAgent() {
      const agentId = this.agentId
      const response = await AgentsHelpers.getAgent(agentId)
      this.agent = response.args[0]
    },
    async getPersonsList() {
      try {
        const response = await PersonsHelpers.getPersonsList()
        const data = response.args[0]
        const newArr = data.map((item, index) => {
          const myObj = {}
          const {
            account_id: accountId,
            emails,
            first_name: firstName,
            last_name: lastName,
            id,
            phones = null,
            roles = null,
            domElementId = `idEventosDestinatario${index}`
          } = item
          const fullName = `${item.first_name} ${item.last_name}`
          Object.assign(myObj, {
            accountId,
            emails,
            firstName,
            lastName,
            id,
            phones,
            roles,
            fullName,
            domElementId
          })
          return myObj
        })
        newArr.sort((a, b) => {
          const result = a.firstName.localeCompare(b.firstName)

          return result !== 0 ? result : a.lastName.localeCompare(b.lastName)
        })

        const filteredArr = newArr.filter(person => {
          const roles = person.roles || {}
          const roleKeys = Object.keys(roles)
          const isOnlyDriver = roleKeys.length === 1 && roleKeys[0] === 'mrn:party_role:driver'

          return !isOnlyDriver
        })

        this.items = filteredArr
        this.fillNotifications()
      } catch (error) {
        if (error.error == 'com.magenta.error.operation_not_allowed') {
          const snackbar = {
            text: i18n.t(
              'fleet_management.persons.persons_tab_all.errors.no_permission'
            )
          }
          this.setSnackbar(snackbar)
        } else {
          const snackbar = {
            text: i18n.t(
              'fleet_management.persons.persons_tab_all.errors.other_error'
            )
          }
          this.setSnackbar(snackbar)
        }
      }
    },
    getNotification(_agentId) {
      this.loadingCriticality = true
      NotificationsHelper.getNotification(_agentId).then(
        response => {
          this.hasNotificationConfig = true
          this.personsNotificationConfig = response.to
          this.selectedCriticality = this.criticalityLevels.find(c => c.value === response.criticality)
          this.originalCriticality = { ...this.selectedCriticality }
          this.$emit('setCriticalityFromNotification', response.criticality)
          this.fillNotifications()
        },
        error => {
          if (error.error !== 'com.magenta.error.not_found') {
            this.errorGettingNotification = true
            const text = NotificationsHelper.getErrorMessageByCode(error.error)
            const snackbar = {
              text
            }
            this.setSnackbar(snackbar)
          }
        }
      ).finally(() => {
        this.loadingCriticality = false
      })
    },
    remove(item) {
      const index = this.persons.indexOf(item)
      if (index >= 0) {
        this.persons[index].checked = false
        this.persons.splice(index, 1)
      }
    },
    resetValues() {
      this.byEmail = false
      this.inbox = false
      this.byMobile = false
      this.byMobileOriginal = false
      this.byEmailOriginal = false
      this.inboxOriginal = false
      this.persons.forEach(element => {
        element.checked = false
      })
      this.persons.splice(0) //reset value
      this.selectedCriticality = { ...this.originalCriticality }
    },
    setAgentId(agentId) {
      this.agentId = agentId
    },
    setAgent(agent) {
      this.agent = agent
    },
    async submit() {
      const agentId = this.agentId
      const allPersons = []

      this.persons.forEach(person => {
        let test = {}
        if (this.byEmail) {
          test = { ...test, email: person.emails[0].email }
        }
        if (this.inbox && person.roles !== null) {
          test = { ...test, inbox: person.id }
        }
        if (this.byMobile) {
          test = { ...test, push: person.id }
        }
        const notificationObj = {
          user_id: person.id,
          account_type: 'business',
          locale: 'es_AR',
          platform_user: person.roles !== null ? true : false,
          channels: { ...test }
        }
        allPersons.push(notificationObj)
      })

      this.personsGroupNotificationIds.forEach(personGroupId => {
        let test = {}
        if (this.byEmail) {
          test = { ...test, email: personGroupId }
        }
        if (this.inbox) {
          test = { ...test, inbox: personGroupId }
        }
        if (this.byMobile) {
          test = { ...test, push: personGroupId }
        }
        const notificationObj = {
          user_id: personGroupId,
          account_type: 'business',
          locale: 'es_AR',
          platform_user: true,
          channels: { ...test }
        }
        allPersons.push(notificationObj)
      })

      //CREATE
      if (!this.hasNotificationConfig) {
        const conditionsAmount = Object.keys(this.agent.conditions).length
        const allCondition = []
        for (let i = 0; i < conditionsAmount; i++) {
          const element = Object.entries(this.agent.conditions)[i]
          switch (element[0]) {
            case 'mrn:agent_condition:speed_limit':
              const condition = {
                condition: element[0],
                type: 'undefined'
              }
              allCondition.push(condition)
              break
            case 'mrn:agent_condition:geofence': {
              const condition = {
                condition: element[0],
                type: element[1].type
              }
              allCondition.push(condition)
              break
            }
          }
        }

        const data = {
          agent_id: agentId,
          to: allPersons,
          enabled: true,
          timestamp: Math.floor(Date.now() / 1000),
          notifiable_events: allCondition,
          criticality: this.selectedCriticality.value
        }

        if (data.to.length > 0 || data.criticality) {
          try {
            const response = await NotificationsHelper.createNotification(data)
            if (!response.hasOwnProperty('error')) {
              this.getNotification(agentId)
              await this.getAgent()
              const snackbar = {
                color: 'success',
                text: i18n.t('fleet_management.agents.alerts.edit_success')
              }
              await this.setSnackbar(snackbar)

              this.hasNotificationConfig = true
            } else {
              const snackbar = {
                text: i18n.t('fleet_management.agents.alerts.edit_error')
              }
              await this.setSnackbar(snackbar)
            }
          } catch (e) {
            const snackbar = {
              text: i18n.t('fleet_management.agents.alerts.edit_error')
            }
            await this.setSnackbar(snackbar)
          } finally {
            this.toggleEditable()
          }
        }
      } else if (
        this.persons.length ||
        this.personsGroupNotificationIds.length ||
        this.selectedCriticality !== this.originalCriticality
      ) {
        //UPDATE
        const data = {
          id: this.agentId,
          data: {
            to: allPersons,
            timestamp: Math.floor(Date.now() / 1000),
            criticality: this.selectedCriticality.value
          }
        }

        try {
          const response = await NotificationsHelper.updateNotification(data)
          if (!response.hasOwnProperty('error')) {
            const agentId = this.$route.params.id
            this.getNotification(agentId)
            this.getAgent()
            const snackbar = {
              color: 'success',
              text: i18n.t('fleet_management.agents.alerts.edit_success')
            }
            this.setSnackbar(snackbar)
          } else {
            const snackbar = {
              text: i18n.t('fleet_management.agents.alerts.edit_error')
            }
            this.setSnackbar(snackbar)
          }
        } catch (e) {
          const snackbar = {
            text: i18n.t('fleet_management.agents.alerts.edit_error')
          }
          this.setSnackbar(snackbar)
        } finally {
          this.toggleEditable()
        }
      } else {
        //DELETE
        const notificationId = agentId
        try {
          const response = await NotificationsHelper.deleteNotification(
            notificationId
          )
          if (!response.hasOwnProperty('error')) {
            this.hasNotificationConfig = false
            this.resetValues()
            const snackbar = {
              color: 'success',
              text: i18n.t('fleet_management.agents.alerts.edit_success')
            }
            this.setSnackbar(snackbar)
          } else {
            const snackbar = {
              text: i18n.t('fleet_management.agents.alerts.edit_error')
            }
            this.setSnackbar(snackbar)
          }
        } catch (e) {
          const snackbar = {
            text: i18n.t('fleet_management.agents.alerts.edit_error')
          }
          this.setSnackbar(snackbar)
        } finally {
          this.toggleEditable()
        }
      }
    },
    toggleEditable() {
      this.editable = !this.editable
      this.$emit('notificationsEmit', this.editable)
    }
  },
  watch: {
    tagsPersonIsEmpty(value) {
      if (this.persons.length === 0) {
        this.inbox = !value
      }
    },
    persons() {
      this.autoCheckInputs()
    },
    valid() {
      this.$emit('validNotificationsEmit', this.valid)
    },
    errorMessage() {
      this.$emit('notificationErrorMessageEmit', this.errorMessage)
    },
    recipientsHasBeenChanged: {
      handler(value) {
        this.onNotificationValueChange(value)
      }
    },
    'connection.session.isOpen': async function(value) {
      if (value) {
        this.editable = true
        await this.getPersonsList()
        if (this.$route.name !== 'agent-create') {
          this.agentId = this.$route.params.id
          await this.getNotification(this.agentId)
          await this.getAgent()
        }
        this.loading = false
      }
    },
    selectedCriticality: {
      immediate: true,
      handler(newVal) {
        if (!this.initializedCriticality && newVal && newVal.value !== undefined) {
          this.originalCriticality = { ...newVal }
          this.initializedCriticality = true
        }
      }
    }
  },
  computed: {
    ...mapGetters('auth', ['connection']),
    hasChangedCriticality() {
      const orig = this.originalCriticality
      const selected = this.selectedCriticality

      if (
        !orig || !selected ||
        typeof orig.value === 'undefined' ||
        typeof selected.value === 'undefined'
      ) {
        return false
      }

      return orig.value !== selected.value
    },
    recipientsHasBeenChanged() {
      const initialRecipientsSorted = this.initialRecipients.toSorted(
        (fst, scd) => fst.fullName.localeCompare(scd.fullName)
      )
      const selectedRecipientsSorted = this.persons.toSorted((fst, scd) =>
        fst.fullName.localeCompare(scd.fullName)
      )
      const personGroupNotificationsIdSorted = Array.isArray(this.personsGroupNotificationIds)
        ? this.personsGroupNotificationIds.toSorted((fst, scd) => fst.localeCompare(scd))
        : []

      const currentAgentPersonTagsIdSorted = Array.isArray(this.personsNotificationConfig)
        ? this.personsNotificationConfig
            .filter(currentAgentTag => currentAgentTag.user_id.includes('group'))
            .map(currentAgentTag => currentAgentTag.user_id)
            .toSorted((fst, scd) => fst.localeCompare(scd))
        : []

      return (
        JSON.stringify(initialRecipientsSorted) !==
          JSON.stringify(selectedRecipientsSorted) ||
        JSON.stringify(personGroupNotificationsIdSorted) !==
          JSON.stringify(currentAgentPersonTagsIdSorted) ||
        this.inbox != this.inboxOriginal ||
        this.byEmail != this.byEmailOriginal ||
        this.byMobile != this.byMobileOriginal ||
        this.hasChangedCriticality
      )
    },
    selectedAllPersons() {
      return (
        this.persons.length > 0 && this.persons.length === this.items.length
      )
    },
    selectedSomePersons() {
      return this.persons.length > 0 && !this.selectedAllPersons
    },
    iconSellectAll() {
      if (this.selectedAllPersons) return 'mdi-close-box'
      if (this.selectedSomePersons) return 'mdi-minus-box'
      return 'mdi-checkbox-blank-outline'
    },
    errorMessage() {
      let message = ''
      if (
        !this.inbox &&
        !this.byEmail &&
        !this.byMobile &&
        (this.persons.length > 0 || !this.tagsPersonIsEmpty)
      ) {
        message = i18n.t(
          'fleet_management.agents.notifications.errors.empty_checkbox_error'
        )
      }
      return message
    },
    errorCheckbox() {
      let message = ''
      if ((this.byEmail || this.inbox || this.byMobile) && (this.persons.length === 0 && this.tagsPersonIsEmpty)) {
        message = i18n.t('fleet_management.agents.notifications.errors.checkbox_error')
      } else {
        message = ''
      }
      return message
    },
    selectedCriticalityObject() {
      if (typeof this.selectedCriticality === 'object') return this.selectedCriticality
      return this.criticalityLevels.find(item => item.value === this.selectedCriticality)
    }
  },
  async created() {
    const connection = this.connection
    this.editable = true
    await this.getPersonsList()
    if (this.$route.name !== 'agent-create' && connection.session.isOpen) {
      this.agentId = this.$route.params.id
      await this.getNotification(this.agentId)
      await this.getAgent()
    }
    this.loading = false
  },
  mounted() {
    let initialValue = null
    if (typeof this.selectedCriticality === 'number' || !this.selectedCriticality) {
      const value = typeof this.selectedCriticality === 'number'
        ? this.selectedCriticality
        : this.$route.name === 'agent-create'
          ? 10
          : null

      initialValue = this.criticalityLevels.find(item => item.value === value)
      this.selectedCriticality = initialValue?.value ?? null
    } else if (typeof this.selectedCriticality === 'object' && this.selectedCriticality.value) {
      this.selectedCriticality = this.selectedCriticality.value
      initialValue = this.criticalityLevels.find(item => item.value === this.selectedCriticality)
    }
    this.loadingCriticality = false
  }
}
</script>

<style lang="scss" scoped>
.dropdown-element-style {
  color: #2b2b2b;
  font-family: Lato, sans-serif;
  font-size: 13px;
  width: 100%;
}
</style>
